// src/contexts/OfferCountContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getArtistOfferCount } from '../api/artistCounts';
import { useArtistAuth } from './ArtistAuthContext';

const OfferCountContext = createContext();

export const OfferCountProvider = ({ children }) => {
  const [offerCount, setOfferCount] = useState(0);
  const { artistUser, checking } = useArtistAuth() || {};

  // バッチ用の件数を取得する関数
  const fetchOfferCount = useCallback(async () => {
    if (checking || !artistUser) {
      return;
    }
    try {
      const data = await getArtistOfferCount();
      setOfferCount(Number(data.count) || 0);
    } catch (error) {
      console.error('Error fetching offer count:', error);
    }
  }, [artistUser, checking]);

  // 回答後に呼び出すための公開関数
  const refreshOfferCount = useCallback(async () => {
    await fetchOfferCount();
  }, [fetchOfferCount]);

  // マウント時に1回だけ取得
  useEffect(() => {
    fetchOfferCount();
  }, [fetchOfferCount]);

  useEffect(() => {
    if (!checking && !artistUser) {
      setOfferCount(0);
    }
  }, [artistUser, checking]);

  return (
    <OfferCountContext.Provider value={{ offerCount, refreshOfferCount }}>
      {children}
    </OfferCountContext.Provider>
  );
};

export const useOfferCount = () => useContext(OfferCountContext);
